<template>
    <!-- CHIME-65610: tag 默认 'div'，Area Intro 等页面传 'h1'。v-html 必须留在静态标签上，勿用 <component :is> -->
    <h1
        v-if="!isTitleEmpty && tag === 'h1'"
        class="site-title"
        :class="align"
        v-bind="$attrs"
        :style="style"
        v-html="formatFontSize(title, size)"
    ></h1>
    <div
        v-else-if="!isTitleEmpty"
        class="site-title"
        :class="align"
        v-bind="$attrs"
        :style="style"
        v-html="formatFontSize(title, size)"
    ></div>
</template>


<script>
import util from '@/common/util';
export default {
    name: 'SiteTitle',
    inheritAttrs: false,
    props: {
        title: {
            type: [String],
            default: ''
        },
        size: {
            type: [Number, String],
            default: '--mg-title-size' // === 34px
        },
        mbSize: {
            type: [Number, String],
            default: '--mg-title-size-mobile' // === 20px
        },
        align: {
            validator: value =>
                ['left', 'right', 'center'].indexOf(value) !== -1,
            default: ''
        },
        tag: {
            // CHIME-65610: 默认 'div' 保持原渲染；Area Intro / Overview 页传 'h1' 作为语义化主标题
            type: String,
            default: 'div'
        }
    },
    computed: {
        isTitleEmpty() {
            return util.isEmptyRichtext(this.title);
        },
        titleSize() {
            return this.platform.isMobile ? this.mbSize : this.size;
        },
        style() {
            return {
                'font-size':
                    typeof this.titleSize === 'number'
                        ? `${this.titleSize}px`
                        : `var(${this.titleSize})`
            };
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media';

.site-title {
    font-family: var(--mg-title-font);
    color: var(--g-primary-color);
    text-align: var(--mg-title-align);
    line-height: var(--mg-title-line-height);
    white-space: unset;
    overflow: unset;
    text-overflow: unset;
    &.left {
        text-align: left;
    }
    &.center {
        text-align: center;
    }
    &.right {
        text-align: right;
    }
    @include media-600 {
        line-height: var(--mg-title-line-height-mobile);
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
        padding: 0;
        line-height: inherit;
    }
}
</style>
